export default __webpack_public_path__ + "84e295f8e9fbce6fb403c47eb309a8fd.webp";